// extracted by mini-css-extract-plugin
export default {"titleContainer":"titleContainer---nJpFU","sharedIconRoot":"sharedIconRoot---UzCLH","sharedIcon":"sharedIcon---oEl0l","sharedIconLight":"sharedIconLight---GvNwp"};